import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import AlertDialog from "../../components/AlertDialog.js";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 350,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "20px",
    minHeight: "300px",
    borderRadius: "8px",
  },
}));

export default function SelectTermsDialog({
  tenantName,
  clientName,
  clientTermList,
  outerSelectedTerms,
  closeDialog,
  onDone
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [selectedTerms, setSelectedTerms] = useState(outerSelectedTerms);
  const [selectedTermNames, setSelectedTermNames] = useState([""]);

const buildSelectedNames = () => {
  const allTermNames = clientTermList.map(term =>
    term.current
      ? `${term.name} (Current Term)`
      : term.name
  );

  if (selectedTerms.includes("ALL")) {
    return [`All (${allTermNames.join(", ")})`];
  }

  return clientTermList
    .filter(term => selectedTerms.includes(parseInt(term.termId)))
    .map(term =>
      term.current
        ? `${term.name} (Current Term)`
        : term.name
    );
};
  
  const [selectTermAlertMsg, setSelectTermAlertMsg] = useState([]);
  const handleDone = () => {
    const names = buildSelectedNames();
    const ids = selectedTerms;
    console.log(ids);
    console.log(names);

    if(ids.length === 0)
      setSelectTermAlertMsg({
        title: "Select Term",
        msg: "You must select at least one active term to run this report.",
      });
    else {
      onDone && onDone(ids, names);
      handleClose();
    }
  };
  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  
const handleToggle = (value) => {
  // Normalize value (number or ALL)
  const normalizedValue = value === "ALL" ? "ALL" : Number(value);

  // --- ALL toggle ---
  if (normalizedValue === "ALL") {
    if (selectedTerms.includes("ALL")) {
      setSelectedTerms([]);
    } else {
      setSelectedTerms([
        "ALL",
        ...clientTermList.map(term => Number(term.termId))
      ]);
    }
    return;
  }

  // --- Individual toggle ---
  let newSelected = selectedTerms.filter(v => v !== "ALL"); // remove ALL first

  if (newSelected.includes(normalizedValue)) {
    // remove
    newSelected = newSelected.filter(v => v !== normalizedValue);
  } else {
    // add
    newSelected.push(normalizedValue);
  }

  // auto-select ALL if everything selected
  const allIds = clientTermList.map(t => Number(t.termId));
  if (newSelected.length === allIds.length) {
    newSelected = ["ALL", ...allIds];
  }

  setSelectedTerms(newSelected);
};

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            maxWidth: "none",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "600px",
              // height: "60%",
              // minWidth: "800px",
              // maxHeight: "600px",
            },
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="alert-dialog-title">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box mt={1} ml={1} sx={{ textAlign: "center", flexGrow: 1 }}>
              Term Selection
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // paddingLeft: 10,
            }}
          >
            <b>Tenant: </b> {tenantName}
          </Typography>
          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // marginLeft: 10,
            }}
          >
            <b>Client:</b> {clientName}
          </Typography>

          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // marginLeft: 10,
            }}
          >
            <b>Please select terms</b>
          </Typography>
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >          
            <Card
              variant="outlined"
              sx={{
                width: "80%",
                maxWidth: 500,
                borderRadius: 2,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent
                sx={{
                  overflowY:
                    clientTermList.length > 5 ? "auto" : "visible",
                  maxHeight: clientTermList.length > 5 ? 250 : "none",
                }}
              >
                {clientTermList ? (
                                  <div
                  style={{
                    maxHeight: 500,
                    minWidth: 300,
                    overflowY: "auto",
                    padding: "8px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif"
                  }}
                >
                  {/* ALL option */}
                  <div>
                    <Checkbox
                      checked={selectedTerms.includes("ALL")}
                      onChange={() => handleToggle("ALL")}
                    />
                    <span>All Terms</span>
                  </div>

                  {/* Terms list */}
                  {clientTermList.map((term) => (
                    <div key={term.termId}>
                      <Checkbox
                        checked={
                          selectedTerms.includes("ALL") ||
                          selectedTerms.includes(parseInt(term.termId))
                        }
                        onChange={() => handleToggle(term.termId)}
                      />
                      <span>{term.name} {term.current && <span>(Current Term)</span>}</span>
                    </div>
                  ))}
                </div>
                ) : (
                  <Typography
                    variant="h3"
                    style={{
                      fontSize: 16,
                      textAlign: "center",
                      marginBottom: 15,
                      // paddingLeft: 0,
                    }}
                  >
                    This client has no term.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Box>
        </DialogContent>
        {clientTermList ? (
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleDone}
              >
                Done
              </Button>
            </Box>
          </DialogActions>
        ) : (
          ""
        )}
      </Dialog>
      {selectTermAlertMsg.msg && (
        <AlertDialog
          title={selectTermAlertMsg.title}
          contentMsg={selectTermAlertMsg.msg}
          closeDialog={() => {
            setSelectTermAlertMsg([]);
          }}
        />
      )}
    </div>
  );
}
